import { ComponentProps, Fragment } from 'react'

import ResponsiveImage from '../../display/ResponsiveImage'
import type { ResponsiveImageProperties } from '../../display/ResponsiveImage/types'

import CardSlider from './CardSlider'

type Photo = {
  image: ResponsiveImageProperties
}

type Props = {
  photos: Photo[]
} & ComponentProps<typeof CardSlider>

export default ({ photos, ...props }: Props) => (
  <Fragment>
    {photos?.length > 1 ? (
      <CardSlider photos={photos} {...props} />
    ) : (
      photos[0] && (
        <ResponsiveImage
          {...photos[0].image}
          alt={props.title}
          zIndex={1}
          cover
        />
      )
    )}
  </Fragment>
)
